export const SETUP_SIGNALR = "SETUP_SIGNALR";
export const LOGOUT = "LOGOUT";
export const CHANGE_CAMPAIGN = "CHANGE_CAMPAIGN";
export const PROCESS_LOGOUT = "PROCESS_LOGOUT";
//chat action types

export const INIT_AGENT_CHAT = 'INIT_AGENT_CHAT';
export const SETUP_CHAT = 'SETUP_CHAT';
export const UPDATE_CHAT_TOKEN = 'UPDATE_CHAT_TOKEN';
export const CREATE_CONVERSATION = 'CREATE_CONVERSATION';
export const ADD_USER_CONVERSATION = 'ADD_USER_CONVERSATION';
export const REMOVE_USER_CONVERSATION = 'REMOVE_USER_CONVERSATION';
export const SELECT_CHANNEL = 'SELECT_CHANNEL';
export const GET_MESSAGES = 'GET_MESSAGES';
export const LEAVE_CURRENT_CONVERSATION = 'LEAVE_CURRENT_CONVERSATION';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const ON_MESSAGE_ADDED = 'ON_MESSAGE_ADDED';
export const ON_MESSAGE_UPDATED = 'ON_MESSAGE_UPDATED';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGE_BULK = 'ADD_MESSAGE_BULK';
export const EDIT_MESSAGE = 'EDIT_MESSAGE';
export const GET_RATING = 'GET_RATING';
export const BIND_CONVERSATION_EVENTS = 'BIND_CONVERSATION_EVENTS';
export const GET_CONVERSATIONS = 'GET_CONVERSATIONS';
export const SETUP_UNREAD_MESSAGES = 'SETUP_UNREAD_MESSAGES';
export const INSERT_CHAT_ACTIVITY = 'INSERT_CHAT_ACTIVITY';
export const ACCEPT_CHAT = 'ACCEPT_CHAT';
export const REJECT_CHAT = 'REJECT_CHAT';
export const TRANSFER_CHAT = 'TRANSFER_CHAT';
export const GET_AGENTS = 'GET_AGENTS';
export const NOTIFY_TYPING = 'NOTIFY_TYPING';
export const ON_TYPING_STARTED = 'ON_TYPING_STARTED';
export const ON_TYPING_MESSAGE = 'ON_TYPING_MESSAGE';
export const ON_TYPING_ENDED = 'ON_TYPING_ENDED';
export const GET_CHAT_HISTORY = 'GET_CHAT_HISTORY';
export const GET_MESSAGES_HISTORY = 'GET_MESSAGES_HISTORY';
